export default __webpack_public_path__ + "AmazonAllegro.17478783.svg";